import { withNamespaces } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const OpenPdfModal = ({ t, isOpen, toggle, pdfObjectUrl }) => {
    const openFileInNewTab = () => {
        window.open(pdfObjectUrl, '_blank');
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                <div>
                    {t('Open PDF')}
                </div>
            </ModalHeader>

            <ModalBody>
                <p>
                    {t('Your PDF has been successfully generated and downloaded.')}
                </p>
                <Button
                    color="secondary"
                    onClick={openFileInNewTab}
                    className="d-flex align-items-center"
                    size="sm"
                >
                    <i className="ri-external-link-line font-size-20 me-1" />
                    {t('Open PDF in New Tab')}
                </Button>
            </ModalBody>

            <ModalFooter>
                <Button onClick={toggle} color="secondary" outline>
                    {t('Close')}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default withNamespaces()(
    OpenPdfModal
);